import { Injectable } from '@angular/core';
import { WebWorkerService } from '../../common/services/web-worker/web-worker.service';
import { RepositoryService } from '../../common/services/repository/repository.service';
import { environment } from '../../../../environments/environment';
import { preCacheHandler } from '../../devices/dashboard/functions/pre-cache-handler';
import { IPreCacheConfig } from '../../devices/dashboard/interfaces/ipre-cache-config';
import { LogService } from '../../common/services/log/log.service';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable({
    providedIn: 'root'
})
export class LocationPreCachingService {

    constructor(
        private logger: LogService,
        private oauthService: OAuthService,
        private webWorkerService: WebWorkerService,
        private repositoryService: RepositoryService
    ) {
    }

    public preCacheLocation(locationIds: number[], user: string) {
        const config = {
            locationIds,
            accessToken: this.oauthService.getAccessToken(),
            apiHosts: environment.hosts,
            publicKey: this.repositoryService.publicKey,
            host: window.location.host,
            path: window.location.pathname,
            protocol: window.location.protocol,
            encrypt: environment.production,
            user
        } as IPreCacheConfig;

        this.webWorkerService
            .run(preCacheHandler, config)
            .then((msg) => this.logger.log(msg))
            .catch(e => this.logger.error(e));
    }
}
